const productShopifyIdDecoder = shopifyId => {
  const decoded = atob(shopifyId)
  const shopifyProductId = decoded.slice(decoded.lastIndexOf("/") + 1)
  return shopifyProductId
}

export default productShopifyIdDecoder
